import get from "lodash/get"

// Позволяет забрать из стора список приложений
export const selectApplicationList = state => {
  return get(state, `applications.data`)
}
